/**
 * Desk “action queue” lines (same rules as the header bell / Priority Pulse entry surface).
 */

/** Same as ExpiryDeskApp: lines inside this window appear in the 90-day pulse surface. */
const IN_PULSE_DAYS = 90;

function getDaysUntilSellBy(month: unknown, year: unknown) {
  const today = new Date();
  const m = Number(month);
  const y = Number(year);
  if (!Number.isFinite(m) || !Number.isFinite(y)) return Number.NaN;
  const sellBy = new Date(y, m - 1, 0);
  return Math.ceil((sellBy.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

/** Month/year must be real calendar bounds so urgency math is trustworthy. */
export function medHasValidExpiry(med: { expiryMonth?: unknown; expiryYear?: unknown }): boolean {
  const m = Number(med?.expiryMonth);
  const y = Number(med?.expiryYear);
  return Number.isFinite(m) && m >= 1 && m <= 12 && Number.isFinite(y) && y >= 1980 && y <= 2105;
}

export type DeskNotificationQueueRow = {
  med: Record<string, unknown>;
  days: number | null;
  needsDate: boolean;
  hints: string[];
  sortKey: number | null;
};

/** Active lines that still need desk action (same idea as the bell queue). */
export function buildDeskNotificationQueue(meds: readonly Record<string, unknown>[]): DeskNotificationQueueRow[] {
  const rows: DeskNotificationQueueRow[] = [];
  for (const med of meds) {
    if (med.status) continue;
    const ok = medHasValidExpiry(med);
    const days = ok ? getDaysUntilSellBy(med.expiryMonth, med.expiryYear) : null;
    const needsDate = !ok;
    const inPulse = ok && days != null && days <= IN_PULSE_DAYS;
    if (!needsDate && !inPulse) continue;
    const hints: string[] = [];
    if (needsDate) hints.push("Add expiry date");
    rows.push({
      med,
      days: days == null ? null : days,
      needsDate,
      hints,
      sortKey: needsDate ? -1e6 : days,
    });
  }
  rows.sort((a, b) => (a.sortKey ?? 0) - (b.sortKey ?? 0));
  return rows;
}
